<template>
    <v-dialog width="570" v-model="isOpenCorrectiveFactor" persistent>
        <v-stepper v-model="currentStep" vertical>
            <v-row class="d-flex justify-center pt-8 pb-2">
                <h2
                    class="
                        d-flex
                        justify-center
                        font-weight-light
                        primary--text
                    "
                >
                    Creando Factor Corrector
                </h2>
            </v-row>
            <v-stepper-step :complete="currentStep > 1" step="1">
                Seleccionando comerciales a los que aplicará
                <small>Use los filtros para ayudarse</small>
            </v-stepper-step>

            <v-stepper-content step="1">
                <AddCorrectiveFactor />
                <v-btn
                    depressed
                    class="mt-2 ml-1"
                    color="primary"
                    @click="currentStep = 2"
                    small
                    :disabled="correctiveFactor.commercials.length == 0"
                >
                    Continuar
                </v-btn>
            </v-stepper-content>

            <v-stepper-step :complete="currentStep > 2" step="2">
                Creando la tabla Factor Corrector
            </v-stepper-step>

            <v-stepper-content step="2">
                <AddingRowsEditTable />
                <v-btn
                    class="ml-1"
                    color="primary"
                    @click="currentStep = 1"
                    small
                >
                    Atrás
                </v-btn>
            </v-stepper-content>

            <v-card-actions class="d-flex justify-end my-n8 mr-4">
                <v-tooltip
                    v-if="currentStep == 2"
                    bottom
                    max-width="470px"
                    color="grey darken-3"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            depressed
                            color="success"
                            @click="
                                submit();
                                close();
                            "
                            :disabled="
                                Object.keys(correctiveFactor.factor_details)
                                    .length == 0
                            "
                            v-bind="attrs"
                            v-on="on"
                        >
                            Guardar
                        </v-btn>
                    </template>
                    <v-row>
                        <v-col class="text-justify" cols="8">
                            Este factor será establecido para el mes en curso.
                            Recuerde que todos los factores correctores
                            anteriores se desactivarán y este pasará a ser el
                            vigente. Así pues, en caso de haber algún factor
                            corrector establecido para alguno de los comerciales
                            seleccionados en este mismo mes este será
                            sustituido.
                        </v-col>
                        <v-col cols="4" class="px-6 align-self-center">
                            <v-icon size="90" color="orange">
                                mdi-alert
                            </v-icon>
                        </v-col>
                    </v-row>
                </v-tooltip>
                <v-btn text color="red" @click="close()"> Cerrar </v-btn>
            </v-card-actions>
        </v-stepper>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import AddCorrectiveFactor from '@/components/AreaPersonal/Calculadora/FactorCorrector/addCorrectiveFactor.vue';
import AddingRowsEditTable from '@/components/AreaPersonal/Calculadora/FactorCorrector/addingRowsEditTable.vue';
import { clone } from '@/util/libUtil.js';
import defaultCorrectiveFactor from '@/util/areaPersonal/defaultCorrectiveFactor';

export default {
    data() {
        return {
            currentStep: 1,
        };
    },
    components: {
        AddCorrectiveFactor,
        AddingRowsEditTable,
    },
    methods: {
        close() {
            this.isOpenCorrectiveFactor = false;
            this.correctiveFactor = clone(defaultCorrectiveFactor);
            this.currentStep = 1;
        },
        submit() {
            for (let commercial in this.correctiveFactor.commercials) {
                this.correctiveFactor.commercial_id_arr.push(
                    this.correctiveFactor.commercials[commercial].id
                );
            }

            this.addCorrectiveFactor();
        },
        ...mapActions('areaPersonal/calculadora', ['addCorrectiveFactor']),
    },
    computed: {
        correctiveFactor: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .correctiveFactor.form;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/correctiveFactor',
                    value
                );
            },
        },
        isOpenCorrectiveFactor: {
            get() {
                return this.$store.state.areaPersonal.calculadora
                    .correctiveFactor.isOpen;
            },
            set(value) {
                this.$store.commit(
                    'areaPersonal/calculadora/isOpenCorrectiveFactor',
                    value
                );
            },
        },
    },
};
</script>